import { SortDirection, SortType } from '@smg-real-estate/hg-search-libs';

export interface LayoutSolutionAgencyConfiguration {
  agency: string;
  showSearchBar: boolean;
  subAgencies: string[];
}

export interface LayoutSolutionRequest {
  agency: string;
  includeSubAgencies: boolean;
  layout: string;
  withSearchbar?: boolean;
  primaryColor: string;
  primaryTextColor: string;
}

export interface HeaderTrackingData {
  eventAction: string;
  eventLabel: string;
  contentLanguage?: string;
}

export enum FallbackSearchType {
  RADIUS_10KM = '10km',
  RADIUS_20KM = '20km',
  PRICE_INCREASE = 'priceIncrease',
}

export interface TrackingData {
  eventAction: string;
  eventLabel: string | undefined;
  eventInteraction: string;
  nonInteraction?: boolean;
  targetUrl?: string;
}

export interface ResultListHeaderSorting {
  sortType: SortType;
  sortDirection: SortDirection;
}

export enum Stage {
  PROD = 'prod',
  TEST = 'test',
  MR = 'mr',
  CYPRESS = 'cypress',
  PLAYGROUND = 'playground',
}
